import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';


export class AuthGuardClientService implements CanActivate {
	constructor(private authService: AuthService) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authService.isLoggedIn && this.authService.userType === 'client') {
			this.authService.setUserTypeNavigation(this.authService.userType);

			return true;
		}

		// Navigate to the login page
		window.location.assign(process.env.LANDING_PAGES_URL);
		return false;
	}
static ctorParameters() { return [ { type: AuthService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/auth-guard-client.service.ts